import { createFluentIcon } from "@fluentui/react-icons";

// Babylon.js color logo — content bounds (110.78, 64.81) to (332.62, 320.97), scaled to fit 20x20
export const BabylonLogo = createFluentIcon(
    "BabylonLogo",
    "1em",
    `<g transform="translate(1.34,0) scale(0.07808) translate(-110.78,-64.81)">
        <path fill="#fff" d="M221.7,64.82l-110.92,64V256.93L221.7,321l110.92-64V128.85Z"/>
        <polygon fill="#e0684b" points="332.62 128.85 297.9 108.81 264.5 128.09 299.22 148.14 332.62 128.85"/>
        <polygon fill="#e0684b" points="144.18 148.14 255.09 84.1 221.7 64.81 110.78 128.85 144.18 148.14"/>
        <polygon fill="#e0684b" points="186.98 212.94 221.7 232.98 256.41 212.94 221.7 192.89 186.98 212.94"/>
        <polygon fill="#bb464b" points="299.22 148.14 299.22 237.65 221.7 282.41 144.18 237.65 144.18 148.14 110.78 128.85 110.78 256.93 221.7 320.97 332.62 256.93 332.62 128.85 299.22 148.14"/>
        <polygon fill="#bb464b" points="221.7 152.81 186.98 172.85 186.98 212.94 221.7 192.89 256.41 212.94 256.41 172.85 221.7 152.81"/>
        <polygon fill="#e0ded8" points="299.22 148.14 256.41 172.85 256.41 212.94 221.7 232.98 221.7 282.41 299.22 237.65 299.22 148.14"/>
        <polygon fill="#d5d2ca" points="144.18 148.14 186.98 172.85 186.98 212.94 221.7 232.98 221.7 282.41 144.18 237.65 144.18 148.14"/>
        <polygon fill="#fff" points="255.09 84.1 297.9 108.81 264.5 128.09 299.22 148.14 256.41 172.85 221.7 152.81 186.98 172.85 144.18 148.14 255.09 84.1"/>
    </g>`
);
